
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partner/apply",
      function () {
        return require("private-next-pages/partner/apply.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partner/apply"])
      });
    }
  